import { combineReducers } from 'redux';
import { Vehicles, AddVehicle, Fields } from './redux/reducers';
import { VehicleCard } from './redux/reducers/vehicleCard';

export const Transport = combineReducers({
  Fields,
  AddVehicle,
  Vehicles,
  VehicleCard,
});
